/**
 * What each server blocking reason of the onboarding means to the owner, and
 * the screen that fixes it. Shared by both first days (full CRM and
 * reservations only).
 */
export type ReasonFix = { copy: string; to?: string };

export function reasonFix(reason: string, restaurant: boolean): { copy: string; to?: string } {
  const known: Record<string, { copy: string; to?: string }> = {
    closed: { copy: 'Vuelve a abrir el negocio antes de publicar.', to: '/negocio' },
    pending_approval: { copy: 'Dale está revisando tu negocio. Te avisamos por correo cuando esté aprobado.' },
    profile: { copy: 'Completa el perfil de tu negocio.', to: '/negocio' },
    location: { copy: 'Marca tu ubicación en el mapa.', to: '/negocio' },
    hours: { copy: 'Agrega al menos un horario abierto.', to: '/agenda' },
    menu: { copy: 'Agrega un producto al menú.', to: '/servicios' },
    reservation_offering: restaurant
      ? { copy: 'Crea el tipo de reserva de mesa.' }
      : { copy: 'Agrega al menos un servicio que se pueda reservar.', to: '/servicios' },
    sessions: { copy: 'Programa al menos una clase en las próximas fechas.', to: '/clases' },
    prepay: { copy: 'Tienes clases con pago anticipado, pero tus cobros en línea todavía no aceptan pagos por adelantado.', to: '/negocio' },
    resources: { copy: 'Agrega al menos una mesa activa.', to: '/mesas' },
    floor_plan: { copy: 'Sube un plano o revisa la distribución de tus mesas.', to: '/mesas' },
  };
  return known[reason] ?? { copy: 'Revisa este paso antes de publicar.' };
}
